import React, { useState } from "react";
import { IDoctor, ITreatment } from "../types/clinic.types";
import { ConfirmationModal } from "./ConfirmationModal";
import { DoctorFormModal } from "./DoctorFormModal"; // Import the new modal
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import bookUrl from "../../../../api/bookUrl";
interface Props {
  doctors: IDoctor[];
  treatments: ITreatment[]; // Needed for the multi-select dropdown
  onDoctorsChange: (doctors: IDoctor[]) => void;
}

// Single Doctor Card
const DoctorCard: React.FC<{
  doctor: IDoctor;
  allTreatments: ITreatment[];
  onDelete: () => void;
  onEdit: () => void; // Changed from (id: string)
}> = ({ doctor, allTreatments, onDelete, onEdit }) => {
  const getAssignedTreatments = () => {
    return doctor?.assignedTreatmentIds
      ?.map((id) => allTreatments.find((t) => t.id === id)?.name)
      .filter(Boolean)
      .join(", ");
  };

  return (
    <div className="doctor-card">
      <img src={doctor.image} alt={doctor.fullName} />
      <div className="doctor-info">
        <h4>{doctor.fullName}</h4>
        <div className="speciality">{doctor.speciality}</div>
        <p>
          <strong>Studies:</strong> {doctor.studies.join(", ")}
        </p>
        <p>
          <strong>Languages:</strong> {doctor.languages.join(", ")}
        </p>
        <p>
          <strong>Treatments:</strong> {getAssignedTreatments() || "None"}
        </p>
        <p>
          <strong>Dentist Available for Booking:</strong>{" "}
          {doctor.IsBookDentist ? "Yes" : "No"}
        </p>
      </div>
      <div className="doctor-actions">
        <button className="btn btn-light" onClick={onEdit}>
          Add Treatment
        </button>
       
      </div>
    </div>
  );
};

// Main Doctors Section
export const Doctors: React.FC<Props> = ({
  doctors,
  treatments,
  onDoctorsChange,
}) => {
  const [deleteCandidate, setDeleteCandidate] = useState<string | null>(null);

  // State for Add/Edit Doctor Modal
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingDoctor, setEditingDoctor] = useState<IDoctor | null>(null);

  const handleOpenAddDoctor = () => {
    setEditingDoctor(null);
    setIsModalOpen(true);
  };

  const handleOpenEditDoctor = (doctor: IDoctor) => {
    setEditingDoctor(doctor);
    setIsModalOpen(true);
  };

  const handleSaveDoctor = (doctorData: IDoctor) => {
    if (editingDoctor) {
      // Edit Mode
      onDoctorsChange(
        doctors.map((d) =>
          d.id === editingDoctor.id ? { ...d, ...doctorData } : d
        )
      );
      console.log("Edited Doctor Data:", doctorData.assignedTreatmentIds);

      bookUrl
        .patch("/bookingclinic/clinic/addTreatmentEmployee", {
          treatmentids: doctorData.assignedTreatmentIds,
          employeeId: doctorData.id,
        })
        .then((res) => {
          console.log(res);
    setIsModalOpen(false);

        })
        .catch(console.error);
    }
  };

  const handleDelete = () => {
    if (!deleteCandidate) return;
    onDoctorsChange(doctors.filter((d) => d.id !== deleteCandidate));
    setDeleteCandidate(null);
  };

  return (
    <section className="page-section doctors">
      <div className="section-header">
        <h2>Doctors</h2>
        
      </div>

      <div className="doctors-grid">
        {doctors.map((doc, i) => (
          <DoctorCard
            key={i}
            doctor={doc}
            allTreatments={treatments}
            onDelete={() => setDeleteCandidate(doc.id)}
            onEdit={() => handleOpenEditDoctor(doc)} // Updated onEdit
          />
        ))}
      </div>

      {deleteCandidate && (
        <ConfirmationModal
          title="Delete Doctor"
          message={`Are you sure you want to delete Dr. ${
            doctors.find((d) => d.id === deleteCandidate)?.fullName
          }?`}
          onConfirm={handleDelete}
          onCancel={() => setDeleteCandidate(null)}
        />
      )}

      {isModalOpen && (
        <DoctorFormModal
          doctor={editingDoctor}
          allTreatments={treatments}
          onClose={() => setIsModalOpen(false)}
          onSave={handleSaveDoctor}
        />
      )}
    </section>
  );
};
